// 案件詳細画面で使用する固定パラメータ
import { createContext } from 'react';

interface FixedValues {
  has_review_approval_status: boolean; // 審査結果_承認状態
  has_loan_approval: boolean; // 融資稟議導入済みフラグ
}

// Note sakuma
// 必要に応じて追加、削除する
const default_context: FixedValues = {
  has_review_approval_status: false,
  has_loan_approval: true,
};

export const FixedValuesContext = createContext<FixedValues>(default_context);
